package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.runtime.Composable

@Composable
actual fun PhotoViewerDialog(
    imageBytes: ByteArray?,
    isLoading: Boolean,
    onSave: (ByteArray) -> Unit,
    onDelete: () -> Unit,
    onDismiss: () -> Unit
) {
    PhotoViewerDialogCompose(
        imageBytes = imageBytes,
        isLoading = isLoading,
        onSave = onSave,
        onDelete = onDelete,
        onDismiss = onDismiss
    )
}
